/** Visible name-numerology chrome per page language. */
export const NAME_NUMEROLOGY_COPY = {
  en: {
    eyebrow: "Chaldean Name Numerology",
    intro:
      "Enter your name to discover your Name Number, personality traits, compatible numbers, and career guidance based on the Chaldean (Vedic) numerology system — the same engine as our full Numerology Calculator.",
    calculating: "Calculating…",
    error: "Could not calculate your name number. Please try again.",
    ratingPrompt: "Was this name numerology accurate?",
    quickReference: "All 9 Name Numbers — Quick Reference",
    compatibility: "Compatibility:",
    luckyColor: "Lucky Color:",
    tilesLabel: "What the name number shows",
    tiles: [
      ["Name Number", "Single-digit value from your full name"],
      ["Letter Breakdown", "Chaldean letter values from 1 to 8"],
      ["Planet + Career", "Ruling graha, traits and lucky day"],
    ],
    nameLabel: "Enter Your Full Name",
    namePlaceholder: "e.g. Rahul Sharma",
    nameHint: "Use English letters only. Spaces and special characters are ignored.",
    submit: "Calculate Name Number",
    resultFor: (name: string) => `Name Number for "${name}"`,
    ruledBy: (planet: string, planetHi: string) => `Ruled by ${planet} (${planetHi})`,
    traits: "Personality Traits",
    strengths: "Strengths",
    challenges: "Challenges",
    details: "Planet + Career Details",
    compatibleNumbers: "Compatible Numbers",
    lessCompatible: "Less Compatible",
    luckyColorLabel: "Lucky Color",
    luckyDay: "Lucky Day",
    careers: "Suitable Career Fields",
    another: "Try Another Name",
  },
  hi: {
    eyebrow: "कैल्डियन नाम अंक ज्योतिष",
    intro:
      "अपना नाम लिखें और कैल्डियन (वैदिक) अंक पद्धति से अपना नामांक, स्वभाव, मित्र अंक और करियर मार्गदर्शन जानें — वही इंजन जो हमारे पूरे अंक ज्योतिष कैलकुलेटर में है।",
    calculating: "गणना हो रही है…",
    error: "नामांक नहीं निकल सका। कृपया फिर से कोशिश करें।",
    ratingPrompt: "क्या यह नामांक परिणाम सही लगा?",
    quickReference: "सभी 9 नामांक — त्वरित संदर्भ",
    compatibility: "अनुकूलता:",
    luckyColor: "शुभ रंग:",
    tilesLabel: "नामांक क्या बताता है",
    tiles: [
      ["नामांक", "पूरे नाम से निकला एक अंक"],
      ["अक्षर-मान", "कैल्डियन पद्धति में अक्षरों के मान 1 से 8"],
      ["ग्रह + करियर", "स्वामी ग्रह, स्वभाव और शुभ दिन"],
    ],
    nameLabel: "अपना पूरा नाम लिखें",
    namePlaceholder: "जैसे Rahul Sharma",
    nameHint: "नाम अंग्रेज़ी अक्षरों में लिखें। स्पेस और विशेष चिह्न गिने नहीं जाते।",
    submit: "नामांक निकालें",
    resultFor: (name: string) => `"${name}" का नामांक`,
    ruledBy: (planet: string) => `स्वामी ग्रह: ${planet}`,
    traits: "स्वभाव",
    strengths: "खूबियाँ",
    challenges: "चुनौतियाँ",
    details: "ग्रह और करियर",
    compatibleNumbers: "मित्र अंक",
    lessCompatible: "कम अनुकूल अंक",
    luckyColorLabel: "शुभ रंग",
    luckyDay: "शुभ दिन",
    careers: "उपयुक्त करियर",
    another: "दूसरा नाम आज़माएँ",
  },
} as const;

export type NameNumerologyCopy = (typeof NAME_NUMEROLOGY_COPY)["en" | "hi"];
